import React from 'react';
import { toast } from 'react-toastify';
import { call, put } from 'redux-saga/effects';

import { Creators as listaInativosActions } from '../ducks/listaInativos';

import { ListaInativosAPI } from '../../services/api';

import {
  WarningToast,
  ErrorToast,
  SuccessToast,
} from '../../components/molecules/Toast';

export function* putListaInativosAtualizarStatus(action) {
  const { idLista, idStatus } = action;

  try {
    const response = yield call(
      ListaInativosAPI.patch,
      `/lista-inativos/${idLista}/atualizar-status`,
      { idStatusLista: idStatus }
    );

    const { success, message } = response.data;

    if (success) {
      toast.success(<SuccessToast size="30">{message}</SuccessToast>);
      yield put(
        listaInativosActions.putListaInativosAtualizarStatusResponse(true, null)
      );
      return;
    }

    throw new Error(message);
  } catch (error) {
    if (error?.message)
      toast.error(<ErrorToast size="30">{error?.message}</ErrorToast>);
    yield put(
      listaInativosActions.putListaInativosAtualizarStatusResponse(false, error)
    );
  }
}
